import {
  Button,
  Link,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
} from "@chakra-ui/react"

import { EXTERNAL_ROUTES } from "@/common/constants/routes"

type CreateStakeAccountModalProps = {
  isOpen: boolean
  onClose: () => void
  onCreateStakeAccount: () => void
}

const CreateStakeAccountModal = ({
  isOpen,
  onClose,
  onCreateStakeAccount,
}: CreateStakeAccountModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay backdropFilter="blur(5px)" />
      <ModalContent maxWidth={408} top={{ base: "unset", lg: "120px" }}>
        <ModalHeader
          borderBottomColor="gray.100"
          borderBottomWidth={1}
          p={4}
          textStyle="h5"
        >
          Stake account required
          <ModalCloseButton right={4} top={4} />
        </ModalHeader>
        <ModalBody>
          <Stack py={2} spacing={4}>
            <Stack spacing={4}>
              <Text>
                To participate in governance, you must first create a stake
                account.
              </Text>
              <Link
                isExternal
                className="no-underline"
                color="primary.600"
                href={EXTERNAL_ROUTES.multiGov.learnMoreAboutStakeAccounts}
              >
                Learn more about stake accounts
              </Link>
            </Stack>
            <Button
              variant="primary"
              width="full"
              onClick={onCreateStakeAccount}
            >
              Create stake account
            </Button>
          </Stack>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default CreateStakeAccountModal
